<section class="experience_section">
    <div class="home__container containerPersonal grid">
        <div class="home__content grid">
            <div class="home__data">
                <!-- Título fijo -->
                <div class="title-container">
                    <h1 class="home__title">
                        Certificaciones y Logros
                    </h1>
                </div>
                
                <!-- Sistema de Filtros -->
                <div class="filters-container">
                    <div class="filter-group">
                        <label class="filter-label">Categoría:</label>
                        <div class="filter-buttons">
                            <button 
                                *ngFor="let category of categories" 
                                class="filter-btn"
                                [class.active]="selectedCategory === category.value"
                                (click)="filterByCategory(category.value)">
                                {{category.label}}
                            </button>
                        </div>
                    </div>
                    
                    <div class="filter-group">
                        <label class="filter-label">Año:</label>
                        <select 
                            class="filter-select"
                            [(ngModel)]="selectedYear"
                            (change)="filterByYear(selectedYear)">
                            <option value="all">Todos los años</option>
                            <option *ngFor="let year of years.slice(1)" [value]="year">{{year}}</option>
                        </select>
                    </div>
                </div>

                <!-- Contador de resultados -->
                <div class="results-counter">
                    <span>Mostrando {{filteredAchievements.length}} de {{achievements.length}} logros</span>
                </div>

                <!-- Contenedor de tarjetas -->
                <div class="card-container">
                    <div 
                        *ngFor="let achievement of filteredAchievements; trackBy: trackByAchievement"
                        class="card"
                        [attr.data-category]="achievement.category"
                        (click)="openAchievement(achievement)">
                        
                        <div class="card-content">
                            <!-- Header con año y categoría -->
                            <header class="card-header">
                                <div class="year-badge">{{achievement.year}}</div>
                                <div class="category-badge">
                                    <span class="category-icon">{{getCategoryIcon(achievement.category)}}</span>
                                    <span class="category-text">{{getCategoryName(achievement.category)}}</span>
                                </div>
                            </header>
                            
                            <!-- Contenido principal -->
                            <div class="description">
                                <h2 class="achievement-title">{{achievement.title}}</h2>
                                <h3 class="achievement-issuer">{{achievement.issuer}}</h3>
                                <p class="achievement-description">
                                    {{achievement.description}}
                                </p>
                                
                                <!-- Stack tecnológico -->
                                <div class="tech-stack">
                                    <span 
                                        *ngFor="let tech of achievement.technologies" 
                                        class="tech-item">
                                        {{tech}}
                                    </span>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Indicador de enlace -->
                        <div class="link-indicator" *ngIf="achievement.link && achievement.link !== '#'">
                            <span>🔗</span>
                        </div>
                    </div>

                    <!-- Mensaje cuando no hay resultados -->
                    <div *ngIf="filteredAchievements.length === 0" class="no-results">
                        <div class="no-results-content">
                            <span class="no-results-icon">🔍</span>
                            <h3>No se encontraron resultados</h3>
                            <p>Intenta cambiar los filtros para ver más logros</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>